import { memo } from 'react'
import type { FC } from 'react'
import { Placeholder } from './styles'
import { ICONS } from './constants'
import { Props } from './types'
import * as S from './styles'

const Icon: FC<Props> = ({ name, size = 16, onClick, ...rest }) => {
  const SelectedIcon = ICONS[name]

  if (!SelectedIcon) return <Placeholder>?</Placeholder>

  return (
    <S.Container $width={size} $height={size}>
      <SelectedIcon onClick={onClick} size={size} {...rest} />
    </S.Container>
  )
}

export default memo(Icon)
